import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modal, ModalBody } from 'reactstrap';

import { UPDATE_POST_SETTING, UPDATE_POST_SETTING_EMPTY } from '../../../../../../../../store/actions';

const UpdatePostSetting = ({ onCloseHandler, postSettingDetails }) => {
  const dispatch = useDispatch();

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { updatePostSetting } = useSelector((state: any) => ({
    updatePostSetting: state?.UpdatePostSetting?.data,
  }));

  useEffect(() => {
    if (updatePostSetting) {
      onCloseHandler();
      return () => {
        dispatch({
          type: UPDATE_POST_SETTING_EMPTY,
        });
      };
    }
  }, [updatePostSetting]);

  const handleYesClick = () => {
    dispatch({
      type: UPDATE_POST_SETTING,
      payload: {
        data: {
          postCreationFlag: postSettingDetails?.postCreationFlag === 0 ? 1 : 0,
          id: postSettingDetails?.id,
        },
      },
    });
  };

  return (
    <Modal isOpen={true} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <div className="mt-4 pt-2 fs-15 mx-2 mx-sm-2">
            <p className="text-muted mx-1 mb-0">
              Are you sure you want to {postSettingDetails?.postCreationFlag === 0 ? 'active' : 'inactive'} post section?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" className="btn w-sm btn-primary " data-bs-dismiss="modal" onClick={handleYesClick}>
            Yes
          </button>
          <button type="button" className="btn w-sm btn-light" onClick={onCloseHandler}>
            No
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UpdatePostSetting;
